export default {
    setUserInfo ({commit }, data) {
        return new Promise((resolve, reject) => {
            var {token, login_account} = data
            commit("setToken", token) 
            localStorage.setItem("token", token)
            commit("setUserName", login_account)
            localStorage.setItem("userName", login_account)
            resolve()
          })
    },
    logout ({commit, data}) {
        return new Promise((resolve, reject) => {
            commit('setToken', '')
            commit("setUserName", '')
            localStorage.removeItem("token")
            localStorage.removeItem('tag')
            localStorage.removeItem("userName")
            localStorage.removeItem("color")
            resolve()
          })
        
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/actions.js